"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertRootIdsMatch = void 0;
const errors_1 = require("./errors");
const parse_1 = require("./parse");
/**
 * A utility to check if the root ID of both given RIDs match exactly. Throws if the root IDs do not match.
 * Example:
 * ```
 * // will not throw
 * assertRootIdsMatch('sharefile:account-123/user-456', 'sharefile:account-123/user-789');
 *
 * // will throw
 * assertRootIdsMatch('sharefile:account-123/user-456', 'sharefile:account-456/user-789');
 * ```
 * @param RID1
 * @param RID2
 * @throws > {@link MatchAssertionError} if the root of each RID does not match
 */
function assertRootIdsMatch(RID1, RID2) {
    const rootId1 = (0, parse_1.parseRID)(RID1).root.id;
    const rootId2 = (0, parse_1.parseRID)(RID2).root.id;
    if (rootId1 !== rootId2) {
        throw new errors_1.MatchAssertionError({ message: 'Root IDs do not match.' });
    }
}
exports.assertRootIdsMatch = assertRootIdsMatch;
//# sourceMappingURL=assertRootIdsMatch.js.map